<template>
  <b-modal
    id="loading-modal"
    ref="loadingModal"
    modal-class="loading-modal"
    hide-header
    hide-footer
    no-close-on-esc
    no-close-on-backdrop
    hide-header-close
    size="sm">
    <Spinner
      :size="size"
      :color="color"
      :thickness="thickness"
    />
    <div
      v-if="label"
      class="loading-label">{{ label }}</div>
  </b-modal>
</template>

<script>
import Spinner from '../Spinner';

export default {
  name: 'SpinnerModal',
  components: {
    Spinner,
  },
  props: {
    size: {
      type: Number,
      required: false,
      default: 20,
    },
    color: {
      type: String,
      required: false,
      default: '#141c20',
    },
    backgroundColor: {
      type: String,
      required: false,
      default: '#FFF',
    },
    thickness: {
      type: Number,
      required: false,
      default: 3,
    },
    label: {
      type: String,
      required: false,
      default: '',
    },
  },
  methods: {
    show() {
      this.$refs.loadingModal.show();
    },
    hide() {
      this.$refs.loadingModal.hide();
    },
  },
};
</script>

<style lang="scss" scoped>
  // label under spinner
  .loading-label {
    text-align: center;
    margin-top: 15px;
  }
</style>
